module.exports = __webpack_public_path__ + "static/img/bg-1.e0c2a4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/app/media/img/bg/bg-1.jpg
// module id = wdHR
// module chunks = 1